import styled from "styled-components";

export const OnboardingDialogContentBox = styled.div`
    min-height: 15.4rem;
    max-height: 20%;
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        min-height: 12.8rem;
    }
`;